import { getField, updateField } from 'vuex-map-fields';
import apiAxios from '../../services/apiAxios';
import moment from 'moment';
import helpers from '../../mixins/helpers';

const state = {
    ventas: [],
};

const mutations = {
    updateField,

    'INICIALIZAR_REPORTE_VENTAS' (state) {
        state.ventas = [];
    },
    'SET_REPORTE_VENTAS' (state, ventas) {
        state.ventas = ventas;
    },
};

const getters = {
    getField,

    ventas (state) {
        return state.ventas;
    }
};

const actions = {
    getReporteVentas ( { commit }, params ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_REPORTE_VENTAS');

            let queryString = '?fechaDesde='+ moment(params.fechaDesde).format('YYYY-MM-DD')
            + '&fechaHasta='+ moment(params.fechaHasta).format('YYYY-MM-DD');
            
            apiAxios.get('holistor/ventas' + queryString)
                .then(res => {
                    commit('SET_REPORTE_VENTAS', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        }, error => {
            reject(error);
        })            
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}